// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .shadow-nav {
  background-color: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 10;
  transition: all ease-in-out 0.5s;
} */
nav {
    font-size: 20px;
    background: #fff;
    height: 100vh;
    width: 258px;
    z-index: 0;
    position: fixed;
    transition: all ease-in-out 0.4s;
    top: 0;
    left: 0;
    border-right:1px solid lightgray;
    box-shadow : 1px 0px 4px lightgray;
    overflow: auto;
  }
  /* @media only screen and (max-width: 600px) {
    nav {
      left: -100%;
    }
  } */
  .side_bar_top {
    background-color: #fff;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid lightgray;
    box-shadow: 0 1px 4px 1px lightgray;
    position: fixed;
    width: 258px;
    z-index: 10;
    transition: all 0.4s ease-in-out 0s;
  }
  .side_bar_top a {
    padding: 0 10px;
  }
  .activeitem {
    color: #4360AB;
    cursor: pointer;
  }
  .sidebar-nav-item{
    border-bottom: 1px solid lightgray;
    padding-bottom: 15px;
    padding-top: 15px;
    padding-left: 15px;
    font-size: 17px;
    cursor: pointer;
  }
  nav ul {
    padding: 0 0;
    list-style: none;
    margin-top: 65px;
  }
  
  nav li {
    padding: 5px 5px;
  }
  nav li a {
    position: relative;
    padding: 10px 15px 10px 15px;
    color: #fff;
    transition: all ease-in-out 0.2s;
  }
  nav li a:hover {
    color:rgb(11 23 248);
  }
  nav li .active::before {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    background-color: #fff;
    height: 100%;
    width: 5px;
    z-index: 20;
  }
  .nav_show {
    width: 100px;
  }
  .nav_show > ul li a {
    padding: 0;
    display: flex;
    font-size: 12px;
    word-break: break-all;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    text-align: center;
  }
  .nav_show > ul li a i{
    font-size: 20px;
  }
  body[data-layout="horizontal"] #page-topbar{
    left: 250px;
  }
  .nav_show  body[data-layout="horizontal"] #page-topbar{
  left: 10px;
  }
  .grow-menu{
    padding-left: 266px;
    transition: all ease-in-out 0.4s;
  }
  .shrink-menu{
    padding-left: 90px;
    transition: all ease-in-out 0.4s;
  }
  .nested-item{
    cursor: pointer;
    background-color: #f8f9fa;
    border: none;
    font-size: 15px;
    padding: 8px 8px 8px 36px;
  }

  .color-rgb{
    color: rgb(11 23 248);
    font-weight: 500;
  }

  .color-black{
    color:black
  }`, "",{"version":3,"sources":["webpack://./src/views/Layout/layout.css"],"names":[],"mappings":"AAAA;;;;;;;GAOG;AACH;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,UAAU;IACV,eAAe;IACf,gCAAgC;IAChC,MAAM;IACN,OAAO;IACP,gCAAgC;IAChC,kCAAkC;IAClC,cAAc;EAChB;EACA;;;;KAIG;EACH;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kCAAkC;IAClC,mCAAmC;IACnC,eAAe;IACf,YAAY;IACZ,WAAW;IACX,mCAAmC;EACrC;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,kCAAkC;IAClC,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,4BAA4B;IAC5B,WAAW;IACX,gCAAgC;EAClC;EACA;IACE,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,OAAO;IACP,sBAAsB;IACtB,YAAY;IACZ,UAAU;IACV,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;IACV,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,2BAA2B;IAC3B,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;EACA,UAAU;EACV;EACA;IACE,mBAAmB;IACnB,gCAAgC;EAClC;EACA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;EACA;IACE,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE;EACF","sourcesContent":["/* .shadow-nav {\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  height: 100%;\r\n  width: 100%;\r\n  position: relative;\r\n  z-index: 10;\r\n  transition: all ease-in-out 0.5s;\r\n} */\r\nnav {\r\n    font-size: 20px;\r\n    background: #fff;\r\n    height: 100vh;\r\n    width: 258px;\r\n    z-index: 0;\r\n    position: fixed;\r\n    transition: all ease-in-out 0.4s;\r\n    top: 0;\r\n    left: 0;\r\n    border-right:1px solid lightgray;\r\n    box-shadow : 1px 0px 4px lightgray;\r\n    overflow: auto;\r\n  }\r\n  /* @media only screen and (max-width: 600px) {\r\n    nav {\r\n      left: -100%;\r\n    }\r\n  } */\r\n  .side_bar_top {\r\n    background-color: #fff;\r\n    justify-content: center;\r\n    align-items: center;\r\n    border-bottom: 1px solid lightgray;\r\n    box-shadow: 0 1px 4px 1px lightgray;\r\n    position: fixed;\r\n    width: 258px;\r\n    z-index: 10;\r\n    transition: all 0.4s ease-in-out 0s;\r\n  }\r\n  .side_bar_top a {\r\n    padding: 0 10px;\r\n  }\r\n  .activeitem {\r\n    color: #4360AB;\r\n    cursor: pointer;\r\n  }\r\n  .sidebar-nav-item{\r\n    border-bottom: 1px solid lightgray;\r\n    padding-bottom: 15px;\r\n    padding-top: 15px;\r\n    padding-left: 15px;\r\n    font-size: 17px;\r\n    cursor: pointer;\r\n  }\r\n  nav ul {\r\n    padding: 0 0;\r\n    list-style: none;\r\n    margin-top: 65px;\r\n  }\r\n  \r\n  nav li {\r\n    padding: 5px 5px;\r\n  }\r\n  nav li a {\r\n    position: relative;\r\n    padding: 10px 15px 10px 15px;\r\n    color: #fff;\r\n    transition: all ease-in-out 0.2s;\r\n  }\r\n  nav li a:hover {\r\n    color:rgb(11 23 248);\r\n  }\r\n  nav li .active::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    left: 0;\r\n    background-color: #fff;\r\n    height: 100%;\r\n    width: 5px;\r\n    z-index: 20;\r\n  }\r\n  .nav_show {\r\n    width: 100px;\r\n  }\r\n  .nav_show > ul li a {\r\n    padding: 0;\r\n    display: flex;\r\n    font-size: 12px;\r\n    word-break: break-all;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    flex-direction: column;\r\n    text-align: center;\r\n  }\r\n  .nav_show > ul li a i{\r\n    font-size: 20px;\r\n  }\r\n  body[data-layout=\"horizontal\"] #page-topbar{\r\n    left: 250px;\r\n  }\r\n  .nav_show  body[data-layout=\"horizontal\"] #page-topbar{\r\n  left: 10px;\r\n  }\r\n  .grow-menu{\r\n    padding-left: 266px;\r\n    transition: all ease-in-out 0.4s;\r\n  }\r\n  .shrink-menu{\r\n    padding-left: 90px;\r\n    transition: all ease-in-out 0.4s;\r\n  }\r\n  .nested-item{\r\n    cursor: pointer;\r\n    background-color: #f8f9fa;\r\n    border: none;\r\n    font-size: 15px;\r\n    padding: 8px 8px 8px 36px;\r\n  }\r\n\r\n  .color-rgb{\r\n    color: rgb(11 23 248);\r\n    font-weight: 500;\r\n  }\r\n\r\n  .color-black{\r\n    color:black\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
